/**
 * @fileoverview White Pages searcher for name prefix search.
 * @module searchers/WhiteSearcher
 */

import { DbSearcher } from './DbSearcher.js';
import { SEARCH_TYPES } from '../constants.js';


/**
 * Manages White Pages search functionality.
 * Searches by initial letters of resident surname or business name.
 * @class
 * @extends DbSearcher
 */
export class WhiteSearcher extends DbSearcher {
    /**
     * Creates a new WhiteSearcher instance.
     * @param {Object} mapApp - The MapApp instance
     * @param {Object} [options={}] - Configuration options
     */
    constructor(mapApp, options = {}) {
        super(mapApp, {
            searcherName: SEARCH_TYPES.WHITE,
            searchMethod: WhiteSearcher.prototype.searchDataForStringPrefix,
            searchMethodOptions: { fields: ['lastName', 'dName', 'userLabel'] },
            emptyMessage: 'Search by initial letters of resident surname or business name.',
            enableActionBarSave: true,
            enableActionBarEdit: true,
            enableActionBarRead: true,
            listerOptions: {
                contentsLabel: 'white pages search results',
                supportsIndent: true,
            },
            ...options
        });
    }




    // ==========================================
    // Search method
    // ==========================================

    /**
     * Searches for items where any specified field starts with the query string.
     * @param {Object} searchPack - The search pack with query and options
     * @returns {Promise<Object>} Search result object with results array and totalCount
     */
    async searchDataForStringPrefix(searchPack) {
        // show loading right before real work?
        //await this.showLoading();
        // build searchPack with our template options (sets fields)
        return this.searchDataWithFieldMatchFunction(searchPack,
            (value, searchPack, field) => value.startsWith(searchPack.query));
    }


    /**
     * Converts the current white pages search into an equivalent advanced search query.
     * Builds a startsWith expression on the dName field and runs it as an advanced search.
     * @override
     */
    makeAdvancedSearch() {
        const searchPack = this.getLastSearchPack();
        const thisQueryStr = searchPack.query;
        if (!thisQueryStr) {
            return;
        }
        //const searchQuery = `(startsWith(dName,"${thisQueryStr}"))`;
        const searchQuery = `(startsWith(lastName,"${thisQueryStr}") or startsWith(dName,"${thisQueryStr}"))`;
        const searchType = SEARCH_TYPES.ADVANCED;
        this.mapApp.programmaticallyRunSearchOnQuery(searchType, searchQuery, false);
    }


    /**
     * Sorts results for white pages display by name.
     * @param {Array} results - The results to sort
     * @returns {Array} The sorted results
     * @override
     */
    sortResults(results) {
        //return this.sortResultsByField(results, 'sort_n', 'dName');
        return this.sortResultsByField(results, 'sort_n', 'lastName');
    }


}
